import{gql as e}from"@apollo/client";const t=e`
  mutation sendContactForm(
    $firstName: String!
    $lastName: String!
    $message: String
    $sender: String!
    $phoneNumber: String
    $placeholders: [PlaceholdersInputType]
    $confirmationEmailPlaceholders: [PlaceholdersInputType]
    $templateId: Int
  ) {
    notification {
      sendContactForm(
        firstname: $firstName
        lastname: $lastName
        message: $message
        projectId: "${process.env.REACT_APP_PROJECT_ID}"
        sender: $sender
        phoneNumber: $phoneNumber
        placeholders: $placeholders
        confirmationEmailPlaceholders: $confirmationEmailPlaceholders
        templateId: $templateId
      )
    }
  }
`;export{t as SEND_CONTACT_FORM_MUTATION};
//# sourceMappingURL=useSendContactForm.graphql.js.map
